import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { CheckoutToolStepTrackingInfo } from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

import { Config } from "@/utils/config.utils";

export const getBazaarvoiceTransaction = (
    data: TypedAnalyticsEvent<CheckoutToolStepTrackingInfo>
) => {
    if (
        data.payload?.eventData?.name === "checkout" &&
        data.payload?.eventData?.stepName === "order confirmation"
    ) {
        const orderId = data.payload?.eventData?.cart.orderId;
        const total =
            data.payload?.eventData?.cart?.totalPrice.toFixed(2) || "0.00";
        const email = data.payload?.eventData?.cart?.email;
        const nickname = data.payload?.eventData?.cart?.name;
        const cartItems = data.payload?.eventData?.cart?.items ?? [];

        if (!orderId) return;
        if (!email) return;
        if (!nickname) return;

        const items = cartItems.map<BV.TransactionDataItem>((item) => ({
            price: item.unitPrice.toFixed(2),
            quantity: item.quantity.toFixed(0),
            name: item.name,
            productId: item.id,
            discount:
                typeof item.reduction === "string"
                    ? item.reduction
                    : `${item.reduction}%`
        }));

        const transactionData: BV.TransactionData = {
            orderId: orderId,
            total: total,
            currency: "EUR",
            email: email,
            locale: Config.getLocale(),
            nickname: nickname,
            items: items
        };

        return transactionData;
    }
};
